// extracted by mini-css-extract-plugin
export default {"TextResizer":"TextResizer_TextResizer__dDSrG"};